import { render } from "./OriginatorMoreCrypto.vue?vue&type=template&id=7af14cdc&scoped=true"
import script from "./OriginatorMoreCrypto.vue?vue&type=script&lang=js"
export * from "./OriginatorMoreCrypto.vue?vue&type=script&lang=js"

import "./OriginatorMoreCrypto.vue?vue&type=style&index=0&id=7af14cdc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7af14cdc"]])

export default __exports__